import React from "react";
import PropTypes from "prop-types";

const SquiggleSmall = ({ className, color }) => {
  switch (color) {
    case `bone`:
      color = `#f4eee3`;
      break;

    case `orange`:
      color = `#e84829`;
      break;

    default:
      break;
  }

  //

  return (
    <svg className={className} viewBox="0 0 447.19 2.58">
      <g>
        <path
          fill="none"
          stroke={color}
          strokeWidth={0.75}
          d="M.26,1.29a3.83,3.83,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.83,3.83,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.83,3.83,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.83,3.83,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.83,3.83,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.83,3.83,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.83,3.83,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.83,3.83,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.83,3.83,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.83,3.83,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.83,3.83,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.83,3.83,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.83,3.83,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.83,3.83,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.83,3.83,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.83,3.83,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.83,3.83,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.83,3.83,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.83,3.83,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.83,3.83,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.83,3.83,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.83,3.83,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.83,3.83,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.83,3.83,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.83,3.83,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.83,3.83,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.82,3.82,0,0,1,5,0,3.82,3.82,0,0,0,5,0,3.83,3.83,0,0,1,5,0,3.82,3.82,0,0,0,5,0"
        />
      </g>
    </svg>
  );
};

SquiggleSmall.defaultProps = {
  className: ``,
  color: `#231f20`
};

SquiggleSmall.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

export default SquiggleSmall;
